import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentTargetValueObject} from "../../../data/value-object/content/ContentTargetValueObject";
import {ContentTargetSearchOption} from "../../../data/search-option/content/ContentTargetSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {ContentTargetIO} from "../../../io/ContentIO";
import {ContentTargetDescription} from "../../../data/description/content/ContentTargetDescription";
import {ContentTargetDescriptor} from "../../../data/descriptor/content/ContentTargetDescriptor";
import ListOption from "../../ListOption";
import {
    ContentTargetSearchOptionDescription
} from "../../../data/description/content/ContentTargetSearchOptionDescription";
import {
    applyContentTargetSearchOption,
    ContentTargetSearchOptionField
} from "../../search-option-field/content/ContentTargetSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentTargetValueObject[]>([])
    const option = useStatePair<ContentTargetSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentTargetIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentTargetDescription}
                descriptor={ContentTargetDescriptor}
                showPost
                onPostClick={() => document.location = '/contents/targets/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/targets/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentTargetSearchOptionDescription}
                fields={ContentTargetSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentTargetSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentTargetDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}